import { gql } from '@apollo/client';

export const CREATE_AUTHORIZATION_CODE_MUTATION = gql`
mutation createAuthorizationCode{
    createAuthorizationCode{
        authorizationCode {
          code
          createdAt
          id
          updatedAt
          userId
          valid
      }
    }
  }
`;